"use client";

import React from "react";

import { Swiper, SwiperProps } from "swiper/react";
import "@/styles/swiper-minimal.css";

interface SliderProps extends SwiperProps {
  children: React.ReactNode;
}

// Reusable Swiper wrapper to render slides with passed configuration and children
const Slider: React.FC<SliderProps> = ({ children, ...props }) => {
  return <Swiper {...props}>{children}</Swiper>;
};

export { Slider };
